export const ErrorMessage = ({ children }) => {

    return (
        <div className={`error-form show in-error`}>
            {children}
        </div>
    )
}
